import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const services = [
  {
    icon: 'FiScissors',
    title: 'Cut & Style',
    desc: 'Precision cutting tailored to your face shape and lifestyle, finished with a signature blowout.',
    price: 'From $80'
  },
  {
    icon: 'FiDroplet',
    title: 'Color & Highlights',
    desc: 'Bespoke color formulation, from subtle balayage to complete transformations.',
    price: 'From $150'
  },
  {
    icon: 'FiWind',
    title: 'Luxury Treatments',
    desc: 'Restorative masks and keratin smoothing treatments for ultimate hair health.',
    price: 'From $60'
  },
  {
    icon: 'FiStar',
    title: 'Extensions',
    desc: 'Premium hand-tied and tape-in extensions for seamless length and volume.',
    price: 'Consultation'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-brand-light relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4">Our Services</h2>
          <div className="w-16 h-1 bg-brand-accent mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white p-8 rounded-sm shadow-sm hover:shadow-xl transition-shadow duration-300 group"
            >
              <div className="w-12 h-12 bg-brand-dark text-white flex items-center justify-center rounded-full mb-6 group-hover:bg-brand-accent transition-colors">
                <SafeIcon name={service.icon} className="w-5 h-5" />
              </div>
              <h3 className="text-xl font-serif mb-3">{service.title}</h3>
              <p className="text-gray-500 font-light mb-6 text-sm leading-relaxed">{service.desc}</p>
              <p className="font-semibold text-brand-dark text-sm uppercase tracking-wider">{service.price}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}